var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account__plan-list-item",class:{ 'account__plan-list-item--dark': _vm.index % 2 === 0 }},[_c('dt',{staticClass:"account__plan-list-item-name"},[_c('strong',[_vm._v(_vm._s(_vm._f("capitalizeFirstLetter")(_vm.name))+":")])]),_c('dd',{staticClass:"weight--light"},[_vm._v(_vm._s(_vm._f("capitalizeFirstLetter")(_vm.value)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }